export default __webpack_public_path__ + "static/media/award-active.c89e1d7b.png";